export const ROUTE_CUSTOMER_SCREEN_SETUP = '/customer-screen'
export const ROUTE_CUSTOMER_SCREEN = '/customer-screen/numbers'
